import { render, staticRenderFns } from "./Textblock.vue?vue&type=template&id=a6c9077c&scoped=true"
import script from "./Textblock.vue?vue&type=script&lang=js"
export * from "./Textblock.vue?vue&type=script&lang=js"
import style0 from "./Textblock.vue?vue&type=style&index=0&id=a6c9077c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c9077c",
  null
  
)

export default component.exports